import { createSelectors } from '@leverege/ui-redux';
import Constants from '../Constants.js';
const initialState = {
  // projectId : 
  //   status : 'loading',
  //   error : { },
  //   blueprints : [
  //      { blueprint0 }
  //   ],
  //  blueprintStatus : {
  //    id : { status, error }
  //  }
  //     
};
function createProjectState(curr, id, status = null, error = null) {
  if (id == null) {
    if (curr == null) {
      return {
        blueprints: [],
        blueprintStatus: {},
        status,
        error
      };
    }
    return {
      blueprints: [],
      blueprintStatus: {},
      ...curr,
      status,
      error
    };
  }
  let rtn = null;
  if (curr == null) {
    rtn = {
      status: null,
      error: null,
      blueprints: [],
      blueprintStatus: {}
    };
  } else {
    rtn = {
      ...curr,
      blueprintStatus: {
        ...curr.blueprintStatus
      }
    };
    if (status == null) {
      delete rtn.blueprintStatus[id];
    } else {
      rtn.blueprintStatus[id] = {
        status,
        error
      };
    }
  }
  return rtn;
}

// eslint-disable-next-line default-param-last
function mergeBlueprint(blueprints = [], blueprint) {
  const nEvents = [...blueprints];
  let eventIndex = -1;
  for (let i = 0; i < nEvents.length; i++) {
    if (nEvents[i].id === blueprint.id) {
      eventIndex = i;
      break;
    }
  }
  if (eventIndex !== -1) {
    nEvents[eventIndex] = blueprint;
  } else {
    nEvents.push(blueprint);
  }
  return nEvents;
}

// eslint-disable-next-line default-param-last
function blueprints(state = initialState, action) {
  switch (action.type) {
    case Constants.BLUEPRINT_STATUS:
      {
        const {
          projectId,
          id,
          status,
          error = null
        } = action;
        const nState = {
          ...state
        };
        nState[projectId] = createProjectState(state[projectId], id, status, error);
        return nState;
      }
    case Constants.BLUEPRINT_LIST:
      {
        const {
          projectId,
          items
        } = action;
        const nState = {
          ...state
        };
        nState[projectId] = createProjectState(state[projectId]);
        nState[projectId].blueprints = items;
        return nState;
      }
    case Constants.BLUEPRINT_GET:
      {
        const {
          projectId = 'shared',
          blueprint
        } = action;
        const nState = {
          ...state
        };
        nState[projectId] = createProjectState(state[projectId]);
        nState[projectId].blueprints = mergeBlueprint(nState[projectId].blueprints, blueprint);
        return nState;
      }
    case Constants.BLUEPRINT_ADD:
      {
        const {
          projectId,
          blueprint
        } = action;
        const nState = {
          ...state
        };
        nState[projectId] = createProjectState(state[projectId]);
        nState[projectId].blueprints = [...nState[projectId].blueprints, blueprint];
        return nState;
      }
    case Constants.BLUEPRINT_REMOVE:
      {
        const {
          projectId,
          blueprintId
        } = action;
        const nState = {
          ...state
        };
        nState[projectId] = createProjectState(state[projectId], blueprintId);
        // eslint-disable-next-line eqeqeq
        nState[projectId].blueprints = nState[projectId].blueprints.filter(r => r.id != blueprintId);
        return nState;
      }
    case Constants.BLUEPRINT_UPDATE:
      {
        const {
          projectId,
          blueprint
        } = action;
        const nState = {
          ...state
        };
        nState[projectId] = createProjectState(state[projectId], blueprint.id);
        nState[projectId].blueprints = nState[projectId].blueprints.map(r => {
          // eslint-disable-next-line eqeqeq
          if (r.id != blueprint.id) {
            return r;
          }
          if (blueprint.permissions == null) {
            blueprint.permissions = r.permissions;
          }
          return blueprint;
        });
        return nState;
      }
    default:
      {
        return state;
      }
  }
}
function getStatus(state, projectId, id) {
  const prjId = projectId || process?.env?.projectId;
  if (state && state[prjId]) {
    if (id != null) {
      const rs = state[prjId].blueprintStatus;
      return rs && rs[id] && rs[id].status ? rs[id].status : null;
    }
    return state[prjId].status;
  }
  return null;
}
function getError(state, projectId, id) {
  const prjId = projectId || process?.env?.projectId;
  if (state && state[prjId]) {
    if (id != null) {
      const rs = state[prjId].blueprintStatus;
      return rs && rs[id] && rs[id].error ? rs[id].error : null;
    }
    return state[prjId].error;
  }
  return null;
}
function getBlueprint(state, projectId, id) {
  const prjId = projectId || process?.env?.projectId || 'shared';
  if (state && state[prjId] && state[prjId].blueprints) {
    return state[prjId].blueprints.find(e => e.id === id) || null;
  }
  return null;
}
function getBlueprints(state, projectId) {
  const prjId = projectId || process?.env?.projectId;
  if (state && state[prjId] && state[prjId].blueprints) {
    return state[prjId].blueprints;
  }
  return [];
}
blueprints.createSelectors = (key, createSetStateKey = false) => {
  return createSelectors(key, {
    getStatus,
    getError,
    getBlueprint,
    getBlueprints
  }, createSetStateKey);
};

// Set up initial defaults to make methods available immediately with default state key
const selectors = blueprints.createSelectors('blueprints', true);
Object.keys(selectors).forEach(key => {
  blueprints[key] = selectors[key];
});
export default blueprints;